module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<h1 class="hideable">API-Analyse</h1>\n\n<div class="blocks hideable">\n	';
 _.each(results, function(r, index) { 
__p+='\n		<div style="left: '+
((__t=( r.left ))==null?'':__t)+
'; width: '+
((__t=( r.width ))==null?'':__t)+
'; z-index: '+
((__t=( r.depth * 1000 ))==null?'':__t)+
'"\n			 class="block depth-'+
((__t=( r.depth ))==null?'':__t)+
' color-'+
((__t=( r.color ))==null?'':__t)+
'" data-index="'+
((__t=( index ))==null?'':__t)+
'"\n			 title="'+
((__t=( r.title ))==null?'':__t)+
' ('+
((__t=( r.start ))==null?'':__t)+
' - '+
((__t=( r.end ))==null?'':__t)+
'; '+
((__t=( r.duration ))==null?'':__t)+
' ms)"\n		></div>\n	';
 }); 
__p+='\n\n	<div class="min">\n		'+
((__t=( min ))==null?'':__t)+
'\n	</div>\n	<div class="max">\n		'+
((__t=( max ))==null?'':__t)+
'\n	</div>\n</div>\n\n<div class="details hideable">\n	';
 _.each(results, function(r, index) { 
__p+='\n	<div style="margin-left: '+
((__t=( (r.depth - 1) * 20 ))==null?'':__t)+
'px"\n		 class="color-'+
((__t=( r.color ))==null?'':__t)+
'" data-index="'+
((__t=( index ))==null?'':__t)+
'"\n		 ';
 if ( r.detail ) { 
__p+='data-detail="'+
((__t=( r.detail ))==null?'':__t)+
'"';
 } 
__p+='\n	>\n		<b>'+
((__t=( r.title ))==null?'':__t)+
'</b>\n		<span>'+
((__t=( Math.round(r.duration) ))==null?'':__t)+
' ms</span>\n	</div>\n	';
 }); 
__p+='\n\n	<hr>\n\n	<div class="color-20">\n		<b>Response Time</b>\n		<span>'+
((__t=( total ))==null?'':__t)+
' ms</span>\n	</div>\n\n	<hr>\n\n</div>\n\n<h1>API-Analyse</h1>\n\n';
}
return __p;
};


//////////////////
// WEBPACK FOOTER
// /Users/bm/app/code/jsapps/modules/apibench/template.html
// module id = 46
// module chunks = 0